<template lang="pug">
  section#CustomWellnessTemplateBuilderView
    WtTile(ancestor)
      WtTile(parent vertical :col="2")
      WtTile(parent vertical :col="8")
        WtTile(child :col="12")
          CustomWellnessTemplateBuilder
      WtTile(parent vertical :col="2")
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import CustomWellnessTemplateBuilder from "@@/MapBuilder/CustomWellnessTemplateBuilder.vue";

export default {
  name: "CustomWellnessTemplateBuilderView",

  components: { WtTile, CustomWellnessTemplateBuilder }
};
</script>

<style lang="sass" scoped></style>
